import { Container, Graphics, NineSlicePlane, Sprite } from 'pixi.js';

import { Shared } from '../App';
import { RadialShine } from './RadialShine';

const defaultOpts = {
    bg: 'panel',
    w: 30,
    h: 30,
    nineSliceOffset: 100,
};

export type PanelOpts = typeof defaultOpts;

export class Panel
{
    public view: Sprite;
    public bg: NineSlicePlane;
    public shine?: RadialShine;
    public container: Container;

    constructor(opts: Partial<PanelOpts> = {})
    {
        const o = { ...defaultOpts, ...opts };

        this.view = new Sprite();

        this.view.anchor.set(0.5);

        this.bg = new NineSlicePlane(Shared.assets.getTexture(o.bg),
            o.nineSliceOffset, o.nineSliceOffset, o.nineSliceOffset, o.nineSliceOffset,
        );

        this.bg.width = o.w;
        this.bg.height = o.h;
        this.bg.x -= this.bg.width / 2;
        this.bg.y -= this.bg.height / 2;

        this.view.addChild(this.bg);

        this.container = new Container();
        this.view.addChild(this.container);
    }

    public turnOnShining(): void
    {
        if (this.shine) return;
        this.shine = new RadialShine();
        this.view.addChild(this.shine);
        this.view.addChild(this.container);

        const mask = new Graphics();
        const maskW = this.bg.width - 12;
        const maskH = this.bg.height - 12;

        mask.beginFill(0xFF0000, 0.5);
        mask.drawRoundedRect(-maskW / 2, -maskH / 2, maskW, maskH, 40);
        this.view.addChild(mask);
        this.shine.mask = mask;
        this.shine.burst();
    }

    public turnOffShining(): void
    {
        if (!this.shine) return;
        const mask = this.shine.mask as Sprite;

        if (mask)
        {
            if (mask.parent) mask.parent.removeChild(mask);
            mask.destroy();
        }

        if (this.shine.parent) this.shine.parent.removeChild(this.shine);
        this.shine.destroy();
        this.shine = undefined;
    }
}
